// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../action-list';
import {getLaborRatesForAccount} from '../../shared/repositories';
import moment from 'moment';
import {updateEffectiveDate} from './labor-rate';

export const readLaborRates = account =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getLaborRatesForAccount(account);

            dispatch({
                data,
                type: actions.UPDATE_LABOR_RATE_CHANGE_RATES
            });

            dispatch(updateEffectiveDate(moment.utc().add(14, 'days').valueOf()));

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/labor-rate-change/action-creators/get-labor-rates.js